import {track as unifiedTrack} from "@amplitude/unified";

const AMPLITUDE_EVENT_SINK_KEY = "__PG_DEVTOOLS_AMPLITUDE_EVENT_SINK__";
const AMPLITUDE_PENDING_EVENTS_KEY = "__PG_PENDING_AMPLITUDE_EVENTS__";

interface IDevToolsAmplitudeEventPayload {
    name: string;
    timestamp: string;
    eventProperties?: Record<string, unknown>;
}

declare global {
    interface Window {
        __PG_DEVTOOLS_AMPLITUDE_EVENT_SINK__?: (event: IDevToolsAmplitudeEventPayload) => void;
        __PG_PENDING_AMPLITUDE_EVENTS__?: IDevToolsAmplitudeEventPayload[];
    }
}

const publishAmplitudeEventToDevtools = (eventInput: Parameters<typeof unifiedTrack>[0], eventProperties?: Parameters<typeof unifiedTrack>[1]) => {
    if (typeof window === "undefined") {
        return;
    }

    const sink = window[AMPLITUDE_EVENT_SINK_KEY];

    const eventName = typeof eventInput === "string" ? eventInput : eventInput.event_type;

    if (!eventName) {
        return;
    }

    const normalizedEventProperties = eventProperties && typeof eventProperties === "object" ? {...(eventProperties as Record<string, unknown>)} : undefined;

    const eventPayload = {
        name: eventName,
        timestamp: new Date().toISOString(),
        eventProperties: normalizedEventProperties
    };

    if (sink) {
        sink(eventPayload);
        return;
    }

    const pendingEvents = window[AMPLITUDE_PENDING_EVENTS_KEY] ?? [];

    pendingEvents.push(eventPayload);
    window[AMPLITUDE_PENDING_EVENTS_KEY] = pendingEvents;
};

/**
 * Custom analytics event; forwards to Amplitude `track` (same args as `@amplitude/unified`).
 * The browser SDK queues events until init finishes, so calling before `initAmplitude` is OK.
 */
export const trackAmplitudeEvent = (...args: Parameters<typeof unifiedTrack>): void => {
    unifiedTrack(...args);
    publishAmplitudeEventToDevtools(args[0], args[1]);
};
import {track as unifiedTrack} from "@amplitude/unified";

const AMPLITUDE_EVENT_SINK_KEY = "__PG_DEVTOOLS_AMPLITUDE_EVENT_SINK__";
const AMPLITUDE_PENDING_EVENTS_KEY = "__PG_PENDING_AMPLITUDE_EVENTS__";

interface IDevToolsAmplitudeEventPayload {
    name: string;
    timestamp: string;
    eventProperties?: Record<string, unknown>;
}

declare global {
    interface Window {
        __PG_DEVTOOLS_AMPLITUDE_EVENT_SINK__?: (event: IDevToolsAmplitudeEventPayload) => void;
        __PG_PENDING_AMPLITUDE_EVENTS__?: IDevToolsAmplitudeEventPayload[];
    }
}

const publishAmplitudeEventToDevtools = (eventInput: Parameters<typeof unifiedTrack>[0], eventProperties?: Parameters<typeof unifiedTrack>[1]) => {
    if (typeof window === "undefined") {
        return;
    }

    const sink = window[AMPLITUDE_EVENT_SINK_KEY];

    const eventName = typeof eventInput === "string" ? eventInput : eventInput.event_type;

    if (!eventName) {
        return;
    }

    const normalizedEventProperties = eventProperties && typeof eventProperties === "object" ? {...(eventProperties as Record<string, unknown>)} : undefined;

    const eventPayload = {
        name: eventName,
        timestamp: new Date().toISOString(),
        eventProperties: normalizedEventProperties
    };

    if (sink) {
        sink(eventPayload);
        return;
    }

    const pendingEvents = window[AMPLITUDE_PENDING_EVENTS_KEY] ?? [];

    pendingEvents.push(eventPayload);
    window[AMPLITUDE_PENDING_EVENTS_KEY] = pendingEvents;
};

/**
 * Custom analytics event; forwards to Amplitude `track` (same args as `@amplitude/unified`).
 * The browser SDK queues events until init finishes, so calling before `initAmplitude` is OK.
 */
export const trackAmplitudeEvent = (...args: Parameters<typeof unifiedTrack>): void => {
    unifiedTrack(...args);
    publishAmplitudeEventToDevtools(args[0], args[1]);
};
